"use strict";
/* Auto Generated */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardItemType = void 0;
var DashboardItemType;
(function (DashboardItemType) {
    DashboardItemType[DashboardItemType["numberOfApps"] = 0] = "numberOfApps";
    DashboardItemType[DashboardItemType["numberOfTranslationKeys"] = 1] = "numberOfTranslationKeys";
    DashboardItemType[DashboardItemType["numberOfTranslationKeysPerApp"] = 2] = "numberOfTranslationKeysPerApp";
    DashboardItemType[DashboardItemType["numberOfTranslationSubmissions"] = 3] = "numberOfTranslationSubmissions";
    DashboardItemType[DashboardItemType["numberOfTranslationVotes"] = 4] = "numberOfTranslationVotes";
    DashboardItemType[DashboardItemType["numberOfSupportedLanguages"] = 5] = "numberOfSupportedLanguages";
    DashboardItemType[DashboardItemType["numberOfDonations"] = 6] = "numberOfDonations";
    DashboardItemType[DashboardItemType["totalDonationAmount"] = 7] = "totalDonationAmount";
    DashboardItemType[DashboardItemType["numberOfLiveGuides"] = 8] = "numberOfLiveGuides";
    DashboardItemType[DashboardItemType["numberOfLiveGuidesPerApp"] = 9] = "numberOfLiveGuidesPerApp";
    DashboardItemType[DashboardItemType["numberOfGuidesPending"] = 10] = "numberOfGuidesPending";
    DashboardItemType[DashboardItemType["numberOfGuidesInReview"] = 11] = "numberOfGuidesInReview";
})(DashboardItemType = exports.DashboardItemType || (exports.DashboardItemType = {}));
